export const IMAGE_REGEX = /(https?:\/\/.*\.(?:png|jpg|jpeg))/;

export const UUID_REGEX =
  /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;

export const CONTENT_DEEPLINK_REGEX =
  /https:\/\/fit.teamexos.com\/ondemand\/([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})/;
